<script>
import OrganizationCreationDialog from '@/components/profile/tabs/OrganizationCreationDialog.vue'
import EmployeeManagementTable from '@/components/profile/administrationManagement/EmployeeManagementTable.vue'
import InboxManagementTab from '@/components/myOrganizations/InboxManagementTab.vue'
import InvitationAndCSVExport
  from '@/components/profile/administrationManagement/EmployeeManagementInvitationAndCSVExport.vue'
import AdministrationManagementSettings
  from '@/components/profile/administrationManagement/settings/AdministrationManagementSettings.vue'
// import UploadServicesTab from "@/components/profile/tabs/UploadServicesTab.vue";
// import PrintParametersTab from "@/components/profile/tabs/PrintParametersTab.vue";
import CoverSheetTemplateAdministrationTab from "@/components/myOrganizations/CoverSheetTemplateAdministrationTab.vue";
import BillingDataTab from "@/components/myOrganizations/BillingDataTab.vue";
import WhitelabelTab from "@/components/myOrganizations/WhitelabelTab.vue";
import LargeTabHeader from "@/components/common/tabs/LargeTabHeader.vue";

export default {
  components: {
    LargeTabHeader,
    InboxManagementTab,
    BillingDataTab,
    CoverSheetTemplateAdministrationTab,
    // PrintParametersTab,
    // UploadServicesTab,
    WhitelabelTab,
    AdministrationManagementSettings,
    InvitationAndCSVExport,
    EmployeeManagementTable,
    OrganizationCreationDialog
  },
  data() {
    return {
      activeTab: 0,
      notification: {
        state: false,
        timeout: 3000,
        type: 'success',
        content: ''
      },
      selectedTab: 0,
      search: null,
      updateOrganization: false,
      userSettingsToggle: {state: false, item: {}}
    }
  },
  computed: {
    treeviewOrganizations() {
      let organizations = this.$store.getters.organizationsWithAdminPermissions

      if (this.search) {
        organizations = organizations?.filter(org => {
          const searchIsNumber = !isNaN(Number(this.search))

          return searchIsNumber
            ? org.OrganizationId === Number(this.search)
            : org.OrganizationName?.toLowerCase().includes(this.search.toLowerCase())
        })
      }
      organizations = organizations.sort((a, b) =>
        a.OrganizationName?.localeCompare(b.OrganizationName)
      )

      const organizationMap = new Map()
      organizations.forEach(org => {
        organizationMap.set(org.OrganizationId, {...org, children: []})
      })

      const nestedOrganizations = []
      organizations.forEach(org => {
        if (org.ParentOrganizationId && organizationMap.has(org.ParentOrganizationId)) {
          organizationMap.get(org.ParentOrganizationId).children.push(organizationMap.get(org.OrganizationId))
        } else {
          nestedOrganizations.push(organizationMap.get(org.OrganizationId))
        }
      })
      return nestedOrganizations
    }
  },
  methods: {
    pickOrganization(selected) {
      if (selected[0]) {
        delete selected[0].children // necessary to remain reactivity globally
        this.$store.commit('SET_SELECTED_ORGANIZATION', selected[0])
        this?.$refs?.employeeManagementTable?.getInvitedPeople()
        this?.$refs?.inboxManagementTable?.getInboxesList()
        if (this.$permissions.hasWhiteLabeling) {
          this.$store.dispatch('getWhiteLabelAssets', true).then(() => {
            this.$store.dispatch('getThemeColors')
          })
        }
        if(this.$permissions.hasInput) {
          this.$refs?.inboxManagementTab?.onInboxCreated()
        }
      }
    },
    renameAndPersist() {
      this.updateOrganization = false
      this.$store.dispatch('renameOrganization', {
        id: this.$store.getters.selectedOrganization.OrganizationId,
        name: this.$store.getters.selectedOrganization.OrganizationName
      })
    },
    onInvited() {
      this?.$refs?.employeeManagementTable?.getInvitedPeople()
      && this.$refs.employeeManagementTable.getInvitedPeople()
    },
    onCreateOrganization() {
      return this.$notify(
        this.$t('page.myOrganizations.organization.created.success'),{type: 'success'})
    },
    onErrorCreatingOrganization() {
      return this.$notify(
        this.$t('page.myOrganizations.organization.created.error'),{type: 'error'})
    },
    onUserSettingsToggle(event) {
      this.userSettingsToggle = event
    }
  }
}
</script>
<template>
  <v-container fluid>
    <!--    <v-card class="pt-0">-->
    <div>
      <AdministrationManagementSettings v-model="userSettingsToggle"/>
      <v-container fluid class="pt-0 pb-0">
        <v-row class="pt-0">
          <!--LEFT PANEL-->
          <v-col cols="2" class="pt-0">
            <v-row>
              <v-col cols="10">
                <v-text-field
                  v-model="search"
                  :label="$t('page.myOrganization.search.organization')"
                  flat
                  hide-details
                  prepend-inner-icon="mdi-magnify"
                  clearable
                  clear-icon="mdi-close-circle-outline">
                </v-text-field>
              </v-col>
              <v-col cols="2" class="align-content-end">
                <OrganizationCreationDialog
                  @created-organization="onCreateOrganization"
                  @error-creating-organization="onErrorCreatingOrganization"
                />
              </v-col>
            </v-row>
            <v-treeview
              :items="treeviewOrganizations"
              activatable
              selection-type="independent"
              dense
              hoverable
              active-class="isActive"
              return-object
              item-key="OrganizationId"
              @update:active="pickOrganization">
              <template #prepend="{ open,item }">
                <v-icon v-if="$store.getters.selectedOrganization && item.hasOwnProperty('OrganizationName')">
                  {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                </v-icon>
              </template>
              <template #label="{item}">
              <span
                v-if="$store.getters.selectedOrganization && item.hasOwnProperty('OrganizationName')"
                :class="$store.getters.selectedOrganization.OrganizationId && $store.getters.selectedOrganization.OrganizationId === item.OrganizationId ? 'isActive' : ''"
                :title="item.id">
                <small class="organization-id-prefix">{{ item.OrganizationId }}:</small> {{ item.OrganizationName }}
              </span>
              </template>
            </v-treeview>
          </v-col>
          <!--RIGHT PANEL-->
          <v-col cols="10" class="pl-8 pr-0 pt-0 pb-0">
            <v-card>
              <v-tabs v-model="activeTab" show-arrows>
                <v-tabs-slider></v-tabs-slider>
                <v-tab>
                  <v-icon>mdi-office-building-outline</v-icon>
                  <span class="pl-1">{{ $t('navigation.general') }}</span>
                </v-tab>
                <v-tab>
                  <v-icon>mdi-account-group-outline</v-icon>
                  <span class="pl-1">{{ $t('navigation.user') }}</span>
                </v-tab>
                <v-tab v-if="$permissions.hasInput">
                  <v-icon>mdi-inbox-outline</v-icon>
                  <span class="pl-1">{{ $t('navigation.inboxes') }}</span>
                </v-tab>
                <v-tab>
                  <v-icon>mdi-file-outline</v-icon>
                  <span class="pl-1">{{ $t('navigation.cover.sheets') }}</span>
                </v-tab>
<!--                <v-tab>-->
<!--                  <v-icon>mdi-cloud-sync-outline</v-icon>-->
<!--                  <span class="pl-1"> {{ $t('navigation.upload.services') }}</span>-->
<!--                </v-tab>-->
<!--                <v-tab>-->
<!--                  <v-icon>mdi-printer-outline</v-icon>-->
<!--                  <span class="pl-1">{{ $t('navigation.print.parameters') }}</span>-->
<!--                </v-tab>-->
                <v-tab v-if="$permissions.hasWhiteLabeling">
                  <v-icon>mdi-palette-swatch-outline</v-icon>
                  <span class="pl-1">{{ $t('navigation.whitelabel') }}</span>
                </v-tab>
                <v-tabs-items v-model="activeTab">
                  <!-- GENERAL-->
                  <v-tab-item>
                    <v-divider/>
                    <v-container fluid>
                      <LargeTabHeader
                        :title="$t('heading.organization.information')"
                        :subtitle="$t('subheading.organization.information')"/>

                      <v-divider></v-divider>

                      <v-row no-gutters>
                        <v-col cols="12">
                          <div v-if="!updateOrganization">
                            <v-card
                              flat
                              tile
                              color="transparent"
                              class="pl-5 py-3">
                              <h3 class="mt-1 text-center">
                                {{ $store.getters.selectedOrganization.OrganizationName }}
                                <v-icon
                                  v-if="$store.getters.selectedOrganization.IsAdmin"
                                  class="mb-2"
                                  @click.prevent.stop="updateOrganization = !updateOrganization">mdi-pencil
                                </v-icon>
                              </h3>
                            </v-card>
                          </div>
                          <div v-else>
                            <v-row class="py-3">
                              <v-col>
                                <v-text-field
                                  id="organizationNameUpdater"
                                  v-model="$store.getters.selectedOrganization.OrganizationName"
                                  :label="$t('page.myOrganization.organization.name.label')"
                                  hide-details
                                  outlined
                                  dense
                                  required
                                />
                              </v-col>
                              <v-col>
                                <v-btn
                                  color="primary"
                                  class="ms-1 me-1"
                                  @click="renameAndPersist">{{ $t('button.confirm') }}
                                </v-btn>
                                <v-btn @click="updateOrganization = false">{{ $t('button.cancel') }}</v-btn>
                              </v-col>
                            </v-row>
                          </div>
                          <BillingDataTab :organization="$store.getters.selectedOrganization"/>
                        </v-col>
                        <v-col
                          v-if="updateOrganization"
                          cols="4">
                          <v-btn
                            color="primary"
                            class="ms-1 me-1"
                            @click="renameAndPersist">
                            {{ $t('button.confirm') }}
                          </v-btn>
                          <v-btn @click="updateOrganization = false">
                            {{ $t('button.cancel') }}
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-tab-item>
                  <!-- USER MANAGEMENT-->
                  <v-tab-item>
                    <v-divider/>
                    <v-container fluid>
                      <LargeTabHeader
                        :title="$t('heading.user.management')"
                        :subtitle="$t('subheading.user.management')"/>

                      <v-divider></v-divider>

                      <v-row>
                        <v-col>
                          <v-card
                            flat
                            tile
                            color="transparent"
                            class="pl-1 pb-3">
                            <InvitationAndCSVExport
                              v-if="selectedTab === 0 && $store.getters.selectedOrganization.IsAdmin"
                              class="text-end ma-0 pa-0"
                              @invited="onInvited"/>
                          </v-card>
                          <EmployeeManagementTable
                            v-if="$store.getters.selectedOrganization.IsAdmin"
                            ref="employeeManagementTable"
                            @onUserSettingsToggle="onUserSettingsToggle"/>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-tab-item>
                  <!-- INBOX MANAGEMENT-->
                  <v-tab-item v-if="$permissions.hasInput">
                    <v-divider/>
                    <InboxManagementTab ref="inboxManagementTab" />
                  </v-tab-item>
                  <!-- COVER SHEETS-->
                  <v-tab-item>
                    <v-divider/>
                    <CoverSheetTemplateAdministrationTab/>
                  </v-tab-item>
                  <!-- UPLOAD SERVICES-->
<!--                  <v-tab-item>-->
<!--                    <v-divider/>-->
<!--                    <UploadServicesTab/>-->
<!--                  </v-tab-item>-->
                  <!-- PRINT PARAMETERS-->
<!--                  <v-tab-item>-->
<!--                    <v-divider/>-->
<!--                    <PrintParametersTab/>-->
<!--                  </v-tab-item>-->
                  <!-- WHITELABEL-->
                  <v-tab-item v-if="$permissions.hasWhiteLabeling">
                    <v-divider/>
                    <WhitelabelTab/>
                  </v-tab-item>
                </v-tabs-items>
              </v-tabs>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <!--    </v-card>-->
    </div>
  </v-container>
</template>
<style scoped>
.isActive {
  font-weight: 800;
}

.organization-id-prefix {
  font-size: 12px;
  font-weight: 300;
}
</style>
